import { formatTimer } from "@utils/misc";
import { Button, ButtonClasses } from "kz-ui-sdk";
import { forwardRef, useCallback, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";
import { useOTPCountDown } from "../FormOTP/hooks/useOTPCountDown";

interface GetCodeButtonProps extends ButtonClasses {
  onGetCode: () => Promise<any>;
  disabled?: boolean;
  className?: string;
  loading?: boolean;
}

export interface GetCodeButtonRef {
  startTimer: (remainingSeconds: number) => void;
}

const GetCodeButton = forwardRef<GetCodeButtonRef, GetCodeButtonProps>(
  ({ onGetCode, disabled = false, className = "", classes, loading = false }: GetCodeButtonProps, ref) => {
    const { t } = useTranslation();
    const { time: countdown, countFrom } = useOTPCountDown();

    useImperativeHandle(ref, () => ({
      startTimer: (remainingSeconds: number) => {
        countFrom(remainingSeconds);
      },
    }));

    const handleGetCode = useCallback(
      async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        onGetCode();
      },
      [onGetCode],
    );

    const formatCountdown = (seconds: number) => {
      return t("resend in ({{seconds}})", { seconds: formatTimer(seconds, { minutes: false, seconds: true }) });
    };

    return (
      <Button
        variant="primary"
        size="sm"
        className={className}
        onClick={handleGetCode}
        disabled={disabled || countdown > 0 || loading}
        classes={classes}
        loading={loading}
        type="button"
      >
        {countdown > 0 ? formatCountdown(countdown) : t("Get Code")}
      </Button>
    );
  },
);

GetCodeButton.displayName = "GetCodeButton";

export default GetCodeButton;
